<div class="container profile-selection-screen">
  <div class="profile-selection-card">
    <div class="page-header">
      <h1>Selecione seu perfil de investidor</h1>
      <p class="page-description">
        Com base nas suas respostas, recomendamos o perfil mais alinhado ao seu perfil de investidor.
        Utilizamos suas respostas para identificar o perfil de investimento mais compatível com você. A recomendação serve como referência para apoiar sua escolha.
        <span class="page-link" (click)="openHelpModal()">
          Como funciona a recomendação de perfil do investidor?
        </span>
      </p>
    </div>
    <div class="profile-options">
      <div *ngFor="let profile of opcoesPerfil" class="profile-option">

        @if(profile.idPerfilInvestimento === perfilRecomendado?.id){
          <div class="status-chip">
            Recomendado
          </div>
        }

        <div class="profile-main" [class.profile-main--selected]="perfilSelecionado === profile.idPerfilInvestimento"
          [class.profile-main--expandido]="perfisExpandidos.includes(profile.idPerfilInvestimento) && perfilSelecionado === profile.idPerfilInvestimento"
          [class.profile-main--expandidos]="perfisExpandidos.includes(profile.idPerfilInvestimento)">

          <div class="profile-left">
            <app-radio name="profile" [value]="profile.idPerfilInvestimento"
              [checked]="perfilSelecionado === profile.idPerfilInvestimento"
              (change)="selectProfile(profile.idPerfilInvestimento)">
            </app-radio>
            <span class="option-title">
              {{ profile.nomePerfilInvestimento }}
            </span>
          </div>
          <div class="profile-right">
            <p class="option-description">
              {{ profile.descricaoPerfilInvestimento }}
            </p>
            <div>
              <button type="button" class="btn btn-white"
                (click)="toggleDistribuicao(profile.idPerfilInvestimento)">
                {{
                perfisExpandidos.includes(profile.idPerfilInvestimento)
                ? 'Ocultar distribuição'
                : 'Ver distribuição'
                }}
  
                @if (perfisExpandidos.includes(profile.idPerfilInvestimento)) {
                <img src="assets/images/icons/fi_chevron-up.svg" alt="Ocultar distribuição" />
                } @else {
                <img src="assets/images/icons/fi_chevron-down.svg" alt="Ver distribuição" />
                }
  
              </button>
            </div>
          </div>
        </div>
        @if(perfisExpandidos.includes(profile.idPerfilInvestimento)){
          <div class="distribution-container">
            <div class="distribution-chart-wrapper">
              <div class="distribution-chart" [style.background-image]="getGradient(profile.distribuicao)">
                <div class="donut-hole">
                </div>
              </div>
            </div>
            <div class="distribution-legend">
              <div class="legend-item" *ngFor="let item of profile.distribuicao">
                <span class="legend-color" [style.background-color]="item.cor">
                </span>
                <span class="legend-label">
                  {{ item.nome }}
                </span>
                <span class="legend-line"></span>
                <span class="legend-value">
                  {{ item.percentual }} %
                </span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    @if(perfilSelecionado && perfilSelecionado !== perfilRecomendado?.id){
      <div class="warning-container d-flex flex-column align-items-center gap-3">
        <app-checkbox class="warning-checkbox" [(checked)]="confirmouPerfilDiferente"
          label="Estou ciente dos riscos ao optar por um perfil diferente do recomendado"
          uncheckedLabelColor="var(--color-danger)" checkedLabelColor="var(--color-primary)">
        </app-checkbox>
      </div>
    }

    <div class="button-content justify-content-center d-flex">
      <button class="btn btn-outline-primary" (click)="goBack()">Voltar</button>
      <button class="btn btn-primary ms-3" type="button"
        [disabled]="!podeAvancar" (click)="confirmOptions()">
        Seguinte
        <img src="assets/images/icons/fi_arrow-right.svg" alt="arrow-right" />
      </button>
    </div>

    <app-modal-explicativo [visible]="exibirModalAjuda" (close)="closeHelpModal()" [score]="perfilRecomendado?.pontuacao ?? 0"
      [perfil]="opcoesPerfil" [title]="'Como funciona a recomendação de perfil?'">
    </app-modal-explicativo>

  </div>